// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page {
    background: white;
    display: block;
    margin: 20px;
    box-shadow: 0 0 0.5cm rgba(0,0,0,0.5);
  }
  #secondPage {
    margin: 0 auto 50px auto;
  }
  .a4.portrait {
    width: 210mm;
    height: 297mm;
  }
  .a4.landscape {
    width: 297mm;
    height: 210mm;
  }
  .page-hidden {
    display: none;
  }
  `, "",{"version":3,"sources":["webpack://./src/valuation/page/page.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,qCAAqC;EACvC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,aAAa;EACf","sourcesContent":[".page {\n    background: white;\n    display: block;\n    margin: 20px;\n    box-shadow: 0 0 0.5cm rgba(0,0,0,0.5);\n  }\n  #secondPage {\n    margin: 0 auto 50px auto;\n  }\n  .a4.portrait {\n    width: 210mm;\n    height: 297mm;\n  }\n  .a4.landscape {\n    width: 297mm;\n    height: 210mm;\n  }\n  .page-hidden {\n    display: none;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
